import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IAccountNumberField {
	settingsId: string;
	onChange: (value: string) => void;
}

const AccountNumberField: React.FC<IAccountNumberField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAccountNumber') }], [t]);

	return (
		<FormInput
			testId="AccountNumberField"
			name={`sbpAccountNumber-${settingsId}`}
			label="accountNumberLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(AccountNumberField);
